import { default as _91_46_46_46page_93cgJiBnMaj6Meta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/[...page].vue?macro=true";
import { default as account_45loginve0A8Zby1GMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/account-login.vue?macro=true";
import { default as _91slug_93bMfLqjSaCrMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/account/[slug].vue?macro=true";
import { default as _91id_93Se68uSxbpbMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/account/holidays/[id].vue?macro=true";
import { default as _91id_937A8gkbR1lVMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/account/holidays/payments/[id].vue?macro=true";
import { default as index2vId5yO7FNMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/account/index.vue?macro=true";
import { default as confirmationFtWZT2odvQMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/booking/confirmation.vue?macro=true";
import { default as processingIUyoAa5o42Meta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/booking/processing.vue?macro=true";
import { default as _91id_939nOlt8wphPMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/booking/step/[id].vue?macro=true";
import { default as _91_46_46_46post_93Gb1we0Dw9HMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/events/[...post].vue?macro=true";
import { default as indexBC9k5BirKFMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/events/index.vue?macro=true";
import { default as _91number_93rHivQAgEjsMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/events/page/[number].vue?macro=true";
import { default as _91_46_46_46page_93k3LvS3d4ZWMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/homes-for-sale/[...page].vue?macro=true";
import { default as logindydVOxabuRMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/login.vue?macro=true";
import { default as _91_46_46_46post_93EYJVCjCvBLMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/news/[...post].vue?macro=true";
import { default as _91slug_93Pvs12U76zgMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/news/category/[slug].vue?macro=true";
import { default as indexx0MT25JSe8Meta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/news/index.vue?macro=true";
import { default as _91number_93jjEKSyru5NMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/news/page/[number].vue?macro=true";
import { default as otpLTLVADndNYMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/otp.vue?macro=true";
import { default as password_45resetlmHOT6Sc8QMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/password-reset.vue?macro=true";
import { default as register0zRyAiRAfTMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/register.vue?macro=true";
import { default as search_45calendarEXex3NpdpDMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/search-calendar.vue?macro=true";
import { default as resultsyDhEaCDUZrMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/search/results.vue?macro=true";
import { default as sitemapDPeVhL5KISMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/sitemap.vue?macro=true";
import { default as style_45guidesYntGW6PkjMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/style-guide.vue?macro=true";
import { default as update_45password9RCI0smHQjMeta } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/update-password.vue?macro=true";
export default [
  {
    name: "page",
    path: "/:page(.*)*",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/[...page].vue")
  },
  {
    name: "account-login",
    path: "/account-login",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/account-login.vue")
  },
  {
    name: "account-slug",
    path: "/account/:slug()",
    meta: _91slug_93bMfLqjSaCrMeta || {},
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/account/[slug].vue")
  },
  {
    name: "account-holidays-id",
    path: "/account/holidays/:id()",
    meta: _91id_93Se68uSxbpbMeta || {},
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/account/holidays/[id].vue")
  },
  {
    name: "account-holidays-payments-id",
    path: "/account/holidays/payments/:id()",
    meta: _91id_937A8gkbR1lVMeta || {},
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/account/holidays/payments/[id].vue")
  },
  {
    name: "account",
    path: "/account",
    meta: index2vId5yO7FNMeta || {},
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/account/index.vue")
  },
  {
    name: "booking-confirmation",
    path: "/booking/confirmation",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/booking/confirmation.vue")
  },
  {
    name: "booking-processing",
    path: "/booking/processing",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/booking/processing.vue")
  },
  {
    name: "booking-step-id",
    path: "/booking/step/:id()",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/booking/step/[id].vue")
  },
  {
    name: "events-post",
    path: "/events/:post(.*)*",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/events/[...post].vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/events/index.vue")
  },
  {
    name: "events-page-number",
    path: "/events/page/:number()",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/events/page/[number].vue")
  },
  {
    name: "homes-for-sale-page",
    path: "/homes-for-sale/:page(.*)*",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/homes-for-sale/[...page].vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/login.vue")
  },
  {
    name: "news-post",
    path: "/news/:post(.*)*",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/news/[...post].vue")
  },
  {
    name: "news-category-slug",
    path: "/news/category/:slug()",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/news/category/[slug].vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/news/index.vue")
  },
  {
    name: "news-page-number",
    path: "/news/page/:number()",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/news/page/[number].vue")
  },
  {
    name: "otp",
    path: "/otp",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/otp.vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/password-reset.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/register.vue")
  },
  {
    name: "search-calendar",
    path: "/search-calendar",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/search-calendar.vue")
  },
  {
    name: "search-results",
    path: "/search/results",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/search/results.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/sitemap.vue")
  },
  {
    name: "style-guide",
    path: "/style-guide",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/style-guide.vue")
  },
  {
    name: "update-password",
    path: "/update-password",
    component: () => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/pages/update-password.vue")
  }
]